import React from 'react';
import type { RichTextNode } from '@airhead-games/shared/content';
import RichTextRenderer from '@/content/rendering/renderers/RichTextRenderer';
import {
  Item,
  ItemContent,
  ItemDescription,
  ItemGroup,
  ItemTitle,
} from '@/components/ui/item';
import { cn } from '@/utilities/cn';

export interface BlockFact {
  label: RichTextNode[];
  value: RichTextNode[];
}

interface BlockFactsProps {
  facts?: BlockFact[];
  className?: string;
}

const BlockFacts: React.FC<BlockFactsProps> = ({ facts = [], className }) => {
  if (facts.length === 0) {
    return null;
  }

  return (
    <ItemGroup
      className={cn('grid gap-3 sm:grid-cols-2 2xl:grid-cols-3', className)}
    >
      {facts.map((fact, index) => (
        <Item
          key={index}
          role="listitem"
          variant="muted"
          className="items-start"
        >
          <ItemContent>
            <ItemDescription className="uppercase">
              <RichTextRenderer nodes={fact.label} />
            </ItemDescription>
            <ItemTitle className="line-clamp-none text-base">
              <RichTextRenderer nodes={fact.value} />
            </ItemTitle>
          </ItemContent>
        </Item>
      ))}
    </ItemGroup>
  );
};

export default BlockFacts;
